// Cliente HTTP dos Banners do Cardapio.

import axios from "axios";

const API = "/api";

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export const bannersApi = {
  // placement: "cardapio" (topo do cardápio) ou "totem" (tela de descanso do totem)
  listar: (placement = "cardapio") =>
    axios.get(`${API}/cardapio-banners`, { ...authHeader(), params: { placement } }),
  criar: (data) => axios.post(`${API}/cardapio-banners`, data, authHeader()),
  atualizar: (id, data) => axios.put(`${API}/cardapio-banners/${id}`, data, authHeader()),
  deletar: (id) => axios.delete(`${API}/cardapio-banners/${id}`, authHeader()),
  reordenar: (ordered_ids, placement = "cardapio") =>
    axios.put(`${API}/cardapio-banners/reorder`, { ordered_ids, placement }, authHeader()),

  // Upload separado do cadastro: o backend recorta em 3:1 e devolve a URL,
  // que só vira banner de verdade quando o POST de criação acontece.
  enviarImagem: (file) => {
    const form = new FormData();
    form.append("file", file);
    return axios.post(`${API}/upload/banner-photo`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Banner em vídeo do topo do cardápio: recorte 3,5:1, sem som, até 15 s.
  // Devolve { image_url, media_type: "video" }.
  enviarVideo: (file) => {
    const form = new FormData();
    form.append("file", file);
    return axios.post(`${API}/upload/banner-video`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
      timeout: 180000,
    });
  },

  // Mídia do totem: foto (só reduz, sem recorte) ou vídeo mp4/webm até 40 MB.
  // Devolve { image_url, media_type }.
  enviarMidiaTotem: (file) => {
    const form = new FormData();
    form.append("file", file);
    return axios.post(`${API}/upload/totem-media`, form, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
      timeout: 180000,
    });
  },
};
